export const convertDateFormat = (dateStr) => {
    // Define the patterns and the corresponding replacement formats
    const patterns = [
        { regex: /^\d{4}-\d{2}-\d{2}$/, format: 'YYYY-MM-DD' }, // YYYY-MM-DD
        { regex: /^\d{2}-\d{2}-\d{2}$/, format: 'YY-MM-DD' },   // YY-MM-DD
        { regex: /^\d{8}$/, format: 'YYYYMMDD' },               // YYYYMMDD
        { regex: /^\d{6}$/, format: 'YYMMDD' },                 // YYMMDD
        { regex: /^\d{4}\.\d{2}\.\d{2}$/, format: 'YYYY.MM.DD' }, // YYYY.MM.DD
        { regex: /^\d{2}\.\d{2}\.\d{2}$/, format: 'YY.MM.DD' }, // YY.MM.DD
        { regex: /^\d{4}-\d{1}-\d{1}$/, format: 'YYYY-M-D' },   // YYYY-M-D
        { regex: /^\d{2}-\d{1}-\d{1}$/, format: 'YY-M-D' },     // YY-M-D
        { regex: /^\d{4}\.\d{1}\.\d{1}$/, format: 'YYYY.M.D' }, // YYYY.M.D
        { regex: /^\d{2}\.\d{1}\.\d{1}$/, format: 'YY.M.D' }    // YY.M.D
    ];

    // Function to pad single digit months/days with leading zero
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }

    // Check against each pattern
    for (let pattern of patterns) {
        if (pattern.regex.test(dateStr)) {
            let parts;
            switch (pattern.format) {
                case 'YYYY-MM-DD':
                    return dateStr;
                case 'YY-MM-DD':
                    parts = dateStr.split('-');
                    return `20${parts[0]}-${parts[1]}-${parts[2]}`;
                case 'YYYYMMDD':
                    return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
                case 'YYMMDD':
                    return `20${dateStr.substring(0, 2)}-${dateStr.substring(2, 4)}-${dateStr.substring(4, 6)}`;
                case 'YYYY.MM.DD':
                    parts = dateStr.split('.');
                    return `${parts[0]}-${parts[1]}-${parts[2]}`;
                case 'YY.MM.DD':
                    parts = dateStr.split('.');
                    return `20${parts[0]}-${parts[1]}-${parts[2]}`;
                case 'YYYY-M-D':
                    parts = dateStr.split('-');
                    return `${parts[0]}-${pad(parts[1])}-${pad(parts[2])}`;
                case 'YY-M-D':
                    parts = dateStr.split('-');
                    return `20${parts[0]}-${pad(parts[1])}-${pad(parts[2])}`;
                case 'YYYY.M.D':
                    parts = dateStr.split('.');
                    return `${parts[0]}-${pad(parts[1])}-${pad(parts[2])}`;
                case 'YY.M.D':
                    parts = dateStr.split('.');
                    return `20${parts[0]}-${pad(parts[1])}-${pad(parts[2])}`;
                default:
                    return false;
            }
        }
    }

    return false;
}